module.exports = __webpack_public_path__ + "static/img/1.be55ebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/1.png
// module id = heUV
// module chunks = 0